/**
 * this is a comprehensive base fragment that includes everything except the associated calendar event
 */
export const RecordTaskInspectionAttemptFragment = gql`
  fragment RecordTaskInspectionAttemptFragment on RecordTaskInspectionAttempt {
    id

    hasReport
    inspectionEndedAt
    inspectionStartedAt
    isDraft
    isLatestAttempt
    isReinspection
    loggedAt
    requestedAt
    requestedFor
    scheduledAt
    scheduledFor
    schedulingNotes
    status
    timeZone

    inspectorUser {
      ...UserDataFragment
    }
    loggedByUser {
      ...UserDataFragment
    }
    organization {
      id
      timeZone
      hasActiveUsersWithActiveExternalCalendars
    }
    recordTaskInspection {
      id
      shouldCreateNewAttempt
      visibleToApplicant

      inspectionTemplate {
        id
        name
        defaultDurationMinutes
      }
      inspectionGroup {
        id
        name
        record {
          id
          uuid

          currentUserHasAccess
          displayIdentifier
          expirationDate
          isRecordClosedOrCanceled

          createdByUser {
            id
          }
          mainBackwardsCompatibleLocationInformation {
            ...BackwardsCompatibleLocationInformationFragment
          }
          recordTemplate {
            id
            uuid

            recordSettingsDerived {
              inspectionCoordinationType
              inspectionCutoffTime
              inspectionRequestSchedulingMode
              inspectionSchedulingInstructions
            }
            recordType {
              id
              addressEntryType
            }
          }
        }
        recordTaskGroup {
          id
          isLocked
          name
          ordinal

          workflow {
            id
            completedAt
            createdAt
            status
            workflowTemplate {
              id
              name
            }
          }
        }
      }
    }
    requestedByUser {
      ...UserDataFragment
    }
    result {
      ...RecordTaskInspectionResultFragment
    }
    scheduledByUser {
      ...UserDataFragment
    }
  }
`

/**
 * this fragment exists to load the absolute minimum needed for inspections table views and associated actions
 */
export const RecordTaskInspectionAttemptOverviewFragment = gql`
  fragment RecordTaskInspectionAttemptOverviewFragment on RecordTaskInspectionAttempt {
    id

    hasReport
    isLatestAttempt
    isReinspection
    requestedFor
    scheduledFor
    schedulingNotes
    status
    timeZone

    calendarEvent {
      ...CalendarEventSummaryFragment
    }
    inspectorUser {
      ...UserDataFragment
    }
    organization {
      id

      hasActiveUsersWithActiveExternalCalendars
      timeZone
    }
    recordTaskInspection {
      id

      shouldCreateNewAttempt
      visibleToApplicant

      inspectionGroup {
        id

        name

        record {
          id
          uuid

          displayIdentifier
          expirationDate
          isRecordClosedOrCanceled

          createdByUser {
            id
          }
          mainBackwardsCompatibleLocationInformation {
            ...BackwardsCompatibleLocationInformationFragment
          }
          recordTemplate {
            id
            recordSettingsDerived {
              inspectionCoordinationType
              inspectionCutoffTime
              inspectionRequestSchedulingMode
            }
            recordType {
              id
            }
          }
          relatedAlerts {
            ...AlertFragment
          }
        }
        recordTaskGroup {
          id
          isLocked
        }
      }
      inspectionTemplate {
        id

        defaultDurationMinutes
        name
      }
    }
    result {
      ...RecordTaskInspectionResultFragment
    }
  }
`

/**
 * this fragment exists so that inspections flows can safely load calendar events; calendar event fragment cannot use this because it'd be self-referencing
 */
export const RecordTaskInspectionAttemptDetailsFragment = gql`
  fragment RecordTaskInspectionAttemptDetailsFragment on RecordTaskInspectionAttempt {
    ...RecordTaskInspectionAttemptFragment
    calendarEvent {
      ...CalendarEventSummaryFragment
    }
  }
`
